module.exports = "/wp-content/plugins/farmacy/assets/js/images/no-image-available-62d2473f8e8ad88e087ff5ccd7eb83ed.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/product-tile/image-display/no-image-available.png
 ** module id = 83
 ** module chunks = 1 2 3 4 5 6 7 9 10 11 13 14 15 16 17 22 25 26 29 32 38 49 67 79 117
 **/